module.exports = __webpack_public_path__ + "static/media/teachers subject.8b9e5f51.svg";